import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";

// 골프코스 리스트 가지고 오기
const get_courselist = async (param, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    pagesize: 10,
    courselistcnt: 0,
    courselist: [],
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/course/courselist",
    //url: 'http://localhost/test.php',
    headers: { Authorization: "Bearer " + token },
    params: {
      countryno: param.countryno,
      searchname: param.searchname,
      pageno: param.pageno,
      findex: param.findex,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_courselist", err);
    result(false, err);
  }
};

// 코스상세보기
const get_courseview = async (param, result) => {
  let finalData = {
    code: "",
    message: "",
    basicinfo: null,
    tourdefine: null,
    awardrulelist: null,
    subcoursecnt: "",
    subcourse: [
      {
        subcourseseq: "",
        subcourseno: "",
        subcoursename: "",
        subcoursehole: [],
      },
    ],
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/course/courseview/" + param.courseno,
    //url: 'http://localhost/test.php',
    headers: { Authorization: "Bearer " + token },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_courseview", err);
    result(false, err);
  }
};

// 코스홀보기
const get_courseholeview = async (courseno, holeno, coursubtype, result) => {
  let finalData = {
    code: "",
    message: "",
    courseholeview: [
      {
        subcoursename: "",
        par: "",
        fieldpath: "",
        fieldmap: "",
        greenpathl: "",
        greenmapl: "",
        greenpathr: "",
        greenmapr: "",
      },
    ],
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    headers: { Authorization: "Bearer " + token },
    url:
      process.env.VUE_APP_API_URL +
      "/course/courseholeview/" +
      courseno +
      "/" +
      coursubtype +
      "/" +
      holeno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_courseholeview", err);
    result(false, err);
  }
};

// 통합관리이벤트정보보기
const get_eventview = async (eventno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventinfo: {},
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: "/event/eventview/" + eventno,
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admineventview", err);
    result(false, err);
  }
};

export default {
  get_courselist,
  get_courseview,
  get_courseholeview,
  get_eventview,
};
